const Ajax = require('common/infra/ajax');

class API {
    getProjectEvents(projectId, options) {
        let path = `/api/projects/${projectId}/events`;
        if(options && options.limit && options.offset) {
            path += `?limit=${options.limit}&offset=${options.offset}`;
        }
        return Ajax.GET(path);
    }

    getDiagramEvents(projectId, diagramId, options) {
        let path = `/api/projects/${projectId}/diagrams/${diagramId}/events`;
        if(options && options.limit && options.offset) {
            path += `?limit=${options.limit}&offset=${options.offset}`;
        }
        return Ajax.GET(path);
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./notify/infra/api/event.js